__turbopack_context__.v({
  "panelWrapper": "Forside-module__M7Juna__panelWrapper",
  "videoWrapper": "Forside-module__M7Juna__videoWrapper",
});
